// Normalize phone number to digits only (removes formatting)
export const normalizePhoneNumber = (phoneNumber: string): string => {
  // Remove any non-digit characters
  return phoneNumber.replace(/\D/g, '');
};